export default __webpack_public_path__ + "static/media/facebook-icon.15b9114e.png";